import client from './client';

/**
 * Code Snapshot API
 *
 * Manages collaborative code snapshots for a session.
 */

/**
 * Get the latest code snapshot for a session (requires auth).
 * @param {string|number} sessionId
 */
export const getSnapshot = (sessionId) => {
  console.log('[code] getSnapshot', sessionId);
  return client.get(`/api/sessions/${sessionId}/code`);
};

/**
 * Save (overwrite) the code snapshot for a session (requires HOST auth).
 * @param {string|number} sessionId
 * @param {{ language: string, content: string }} data
 */
export const saveSnapshot = (sessionId, data) => {
  console.log('[code] saveSnapshot', sessionId, data?.language);
  return client.post(`/api/sessions/${sessionId}/code`, data);
};

/**
 * Execute the code snapshot on the backend sandbox (requires HOST auth).
 * @param {string|number} sessionId
 * @param {{ language: string, content: string, stdin?: string }} data
 */
export const executeCode = (sessionId, data) => {
  console.log('[code] executeCode', sessionId, data?.language);
  return client.post(`/api/sessions/${sessionId}/code/execute`, data);
};
